module.exports = __webpack_public_path__ + "static/media/mthree.12757578.png";